import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

const { breakpoints } = constants;
const { mediaQuery } = mediaQueryStyles;
const { xs, sm, md } = breakpoints.BreakpointNames;

const greyDark = constants.colors.ui.neutral[700];

export const rootCss: CSSObject = {
  backgroundColor: constants.colors.ui.neutral[50],
  borderTop: `1px solid ${constants.colors.ui.neutral[100]}`,
  padding: "0 15px 30px 15px",
  display: "flex",
  flexDirection: "column",
  [mediaQuery.downTo(sm)]: {
    padding: "0 20px 30px 20px",
  },
};

export const relatedContentTitle: CSSObject = {
  color: greyDark,
  fontFamily: "Noto Serif",
  fontWeight: "700",
  marginTop: "50px",
};

export const gridCss: CSSObject = {
  gridGap: "15px",
  gridTemplateColumns: "repeat(2, 1fr)",
  [mediaQuery.upTo(xs)]: {
    gridTemplateColumns: "repeat(1, 1fr)",
  },
  [mediaQuery.downTo(md)]: {
    gridTemplateColumns: "repeat(4, 1fr)",
  },
};
